import axios from '@/api/axios';
import type {BusinessAgreementView} from '@/types';

const BASE_URL = '/v2/admin/business/agreement';

export const agreementService = {
  get: async (businessId: string): Promise<BusinessAgreementView> => {
    const response = await axios.get<BusinessAgreementView>(
      `${BASE_URL}/${businessId}`,
    );
    return response?.data;
  },

  // The negotiated agreement for the business to sign, already uploaded to S3.
  uploadCustom: async (
    businessId: string,
    key: string,
  ): Promise<BusinessAgreementView> => {
    const response = await axios.put<BusinessAgreementView>(
      `${BASE_URL}/${businessId}/custom`,
      {key},
    );
    return response?.data;
  },

  // The agreement in force; the one it replaces moves to the history.
  replaceFinal: async (
    businessId: string,
    key: string,
  ): Promise<BusinessAgreementView> => {
    const response = await axios.put<BusinessAgreementView>(
      `${BASE_URL}/${businessId}/final`,
      {key},
    );
    return response?.data;
  },
};
